import { Alert, Spin } from "antd"
import React, { useEffect, useState } from "react"
import { Directory } from "./Directory"
import { DistributorList } from "./distributorsList/DistributorList"
import { useGetCityDistributors } from "./state/hooks"
import { YandexMap } from "./YandexMap"

export const  MapContainer = ({ field, geoCode, cities, city }) => {
    
    const { lat, lng } = geoCode
    const { state: { distributors_of_city }, getDistributorsOfCity, getDistributorsAll } = useGetCityDistributors()

    const [prevCity, setPrevCity] = useState('');
    const [sortDistributor, setSortDistributor] = useState(false)
    const [coordinates, setCoordinates] = useState({ center: [lat, lng], zoom: 10 })
    
    useEffect(()=> {
        getDistributorsOfCity(city)
        setCoordinates({ center: [lat, lng], zoom: 10 })
        setPrevCity(city)
    }, [geoCode])

    useEffect(()=> {
        setSortDistributor(distributors_of_city)
    }, [distributors_of_city])

    const sortDistrubutor = id => {
        const selectDistributor = distributors_of_city.find(fl => fl.id === id)
        const sliceDistributor = distributors_of_city.filter(fl => fl.id !== id)
        sliceDistributor.unshift(selectDistributor)
        setSortDistributor(sliceDistributor)
    }

    const getDistributors = (city, geocode) => {
        console.log(city)
        if(prevCity === city) return
        if(city === 'вся россия') getDistributorsAll()
        if(city !== 'вся россия') getDistributorsOfCity(city)
        setSortDistributor(distributors_of_city)
        setCoordinates(geocode)
        setPrevCity(city)
    }

    return (
        <div className="map">
            
            <Directory cities={cities} getDistributors={getDistributors} />

            <div className="map-container">
                <div className="map-container__item">
                    {   sortDistributor.length === 0 ? <Spin/> :
                        !sortDistributor ? <Alert type="info" message="Не найдено дистрибьюторов, выберите другой город"/> : 
                        <DistributorList distributors={sortDistributor} field={field} setCoordinates={setCoordinates} />
                    }
                </div>
                <div className="map-container__item">
                    <YandexMap distributors={distributors_of_city} sortDistrubutor={sortDistrubutor} coordinates={coordinates}/>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/pages/projects/distributors/MapContainer.js